import { render, staticRenderFns } from "./FormShipping.vue?vue&type=template&id=36d613ad"
import script from "./FormShipping.vue?vue&type=script&lang=js"
export * from "./FormShipping.vue?vue&type=script&lang=js"
import style0 from "./FormShipping.vue?vue&type=style&index=0&id=36d613ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports